
export default class PaintManager {
  constructor (paints) {
    this.paints = paints;
  }

  use (id) {
    const found = this.paints.find((v) => v.id === id);
    if (found !== undefined) {
      return found.color;
    }
    return '#ffffff';
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/manager/PaintManager.js